import React from 'react'
import { Field } from 'react-final-form'
import PropTypes from 'prop-types'

import UIInput from './index'

const renderField = ({ input, label, meta, className, disabled, ...rest }) => {
  const { touched, error, submitError, dirtySinceLastSubmit } = meta
  const hasError = touched && (error || (submitError && !dirtySinceLastSubmit))

  return (
    <UIInput
      className={className}
      disabled={disabled}
      hasError={hasError}
      input={input}
      label={label}
      meta={meta}
      {...rest}
    />
  )
}

renderField.propTypes = {
  className: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
}

const Input = ({
  label = '',
  mask = null,
  name,
  className = '',
  disabled = false,
  ...rest
}) => (
  <Field
    className={className}
    disabled={disabled}
    label={label}
    mask={mask}
    name={name}
    render={renderField}
    {...rest}
  />
)

Input.Component = renderField

Input.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  name: PropTypes.string.isRequired,
}

export default Input
